const root = document.documentElement

if (root.dataset.themePreference === "system") {
  const dark = window.matchMedia("(prefers-color-scheme: dark)").matches
  root.classList.toggle("dark", dark)
  document.querySelector("[data-theme-color]").content = dark ? "#17200e" : "#f8fafc"
}
